import React from 'react';
import SubLayout from '../../components/Layout/SubLayout';
import strings from '../../components/Language';
import 'onsenui/css/onsenui.css';
import 'onsenui/css/onsen-css-components.css';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import "./reward.scss";

import NoDataFound from './../../assets/images/icons/no_data_found.svg';
import { IconChevronRight, IconZap, IconUsers } from '../../components/Icons';

import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from './../../components/config/api.js';
import { getToken, storeUserData } from './../../components/Util';
import _ from 'lodash';
import moment from 'moment';
import LoaderContext from '../../components/Loader/LoaderContext.js';
import { Modal } from '@mui/material';
import SwipeableViews from 'react-swipeable-views';
import NativeDateField from '../../components/NativeDateField';

class RewardScreen extends React.Component {
	static contextType = LoaderContext;
	constructor(props) {
		super(props);
		this.state = {
			access_token: "",
			tabValue: 0,
			data: [],
			profit_data: [],
			profit_data_is_load: false,
			activation_reward: [],
			activation_reward_is_load: false,
			profit_reward: [],
			profit_reward_is_load: false,
			showModal: false,
			showModalData: {},
			TP_startDate: null,
			TP_endDate: null,
			TP_next_page_url: null,
			TP_prev_page_url: null,
			BQ_startDate: null,
			BQ_endDate: null,
			BQ_next_page_url: null,
			BQ_prev_page_url: null,
			PQ_startDate: null,
			PQ_endDate: null,
			PQ_next_page_url: null,
			PQ_prev_page_url: null,
			filterProfit: 0,
			filterProfitReward: 0,
		}
		this.handleChange = this.handleChange.bind(this);

	}

	handleChange(event, newValue) {
		const self = this;
		self.setState({ tabValue: newValue });
	};

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			this.setState({ access_token: token });
			setTimeout(() => {
				this.getData();
				this.getProfitReport();
				this.getActivationReward();
				this.getProfitReward();
			});
		}
	}

	getData() {
		const { setLoading } = this.context;
		setLoading(true);
		var self = this;
		axios({
			method: 'GET',
			url: api.reward,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {
			if (ress.data && ress.data.error === 200) {
				self.setState({ data: ress.data.data });
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	getProfitReport() {
		const { setLoading } = this.context;
		setLoading(true);
		var self = this;
		var API_URL = api.profit_report;
		if (this.state.TP_startDate && this.state.TP_endDate) {
			API_URL = api.profit_report + "?start_date=" + (this.state.TP_startDate ? moment(this.state.TP_startDate).format("YYYY-MM-DD") : "") + "&end_date=" + (this.state.TP_endDate ? moment(this.state.TP_endDate).format("YYYY-MM-DD") : "");
		}
		axios({
			method: 'GET',
			url: API_URL,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {
			if (ress.data && ress.data.error === 200) {
				self.setState({
					profit_data: (ress.data.data && ress.data.data.data) ? ress.data.data.data : [],
					profit_data_is_load: true,
					filterProfit: ress.data.message,
					TP_next_page_url: ress.data.data.next_page_url,
					TP_prev_page_url: ress.data.data.prev_page_url,
				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	getActivationReward() {
		const { setLoading } = this.context;
		setLoading(true);
		var self = this;
		var API_URL = api.activation_reward;
		if (this.state.BQ_startDate && this.state.BQ_endDate) {
			API_URL = api.activation_reward + "?start_date=" + (this.state.BQ_startDate ? moment(this.state.BQ_startDate).format("YYYY-MM-DD") : "") + "&end_date=" + (this.state.BQ_endDate ? moment(this.state.BQ_endDate).format("YYYY-MM-DD") : "");
		}
		axios({
			method: 'GET',
			url: API_URL,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {
			if (ress.data && ress.status === 200) {
				self.setState({
					activation_reward: (ress.data.data) ? ress.data.data : [],
					activation_reward_is_load: true,
					filterActivationReward: ress.data.total_amount,
					BQ_next_page_url: (ress.data && ress.data.links && ress.data.links.next) ? ress.data.links.next : null,
					BQ_prev_page_url: (ress.data && ress.data.links && ress.data.links.prev) ? ress.data.links.prev : null,

				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			console.log(e)
			setLoading(false);
		});
	};

	getProfitReward() {
		const { setLoading } = this.context;
		setLoading(true);
		var self = this;
		var API_URL = api.profit_reward;
		if (this.state.PQ_startDate && this.state.PQ_endDate) {
			API_URL = api.profit_reward + "?start_date=" + (this.state.PQ_startDate ? moment(this.state.PQ_startDate).format("YYYY-MM-DD") : "") + "&end_date=" + (this.state.PQ_endDate ? moment(this.state.PQ_endDate).format("YYYY-MM-DD") : "");
		}
		axios({
			method: 'GET',
			url: API_URL,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {

			if (ress.data && ress.status === 200) {
				self.setState({
					profit_reward: (ress.data.data) ? ress.data.data : [],
					profit_reward_is_load: true,
					filterProfitReward: ress.data.total_amount,
					PQ_next_page_url: (ress.data && ress.data.links && ress.data.links.next) ? ress.data.links.next : null,
					PQ_prev_page_url: (ress.data && ress.data.links && ress.data.links.prev) ? ress.data.links.prev : null,
				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	getNextDataTP(API) {
		if (!API) {
			toast.error(strings.URI_not_found);
			return false;
		}
		var API_URL = API;
		if (this.state.TP_startDate && this.state.TP_endDate) {
			API_URL = API + "&start_date=" + (this.state.TP_startDate ? moment(this.state.TP_startDate).format("YYYY-MM-DD") : "") + "&end_date=" + (this.state.TP_endDate ? moment(this.state.TP_endDate).format("YYYY-MM-DD") : "");
		}
		var self = this;
		self.setState({
			nextPageLink: "",
			prevPageLink: "",
		});
		const { setLoading } = this.context;
		setLoading(true);
		axios({
			method: 'GET',
			url: API_URL,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {
			if (ress.data && ress.data.error === 200) {
				self.setState({
					profit_data: [...self.state.profit_data, ...ress.data.data.data],
					profit_data_is_load: true,
					filterProfit: ress.data.message,
					TP_next_page_url: ress.data.data.next_page_url,
					TP_prev_page_url: ress.data.data.prev_page_url,
				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	getNextDataBQ(API) {
		if (!API) {
			toast.error(strings.URI_not_found);
			return false;
		}
		var API_URL = API;
		if (this.state.BQ_startDate && this.state.BQ_endDate) {
			API_URL = API + "&start_date=" + (this.state.BQ_startDate ? moment(this.state.BQ_startDate).format("YYYY-MM-DD") : "") + "&end_date=" + (this.state.BQ_endDate ? moment(this.state.BQ_endDate).format("YYYY-MM-DD") : "");
		}
		var self = this;
		self.setState({
			nextPageLink: "",
			prevPageLink: "",
		});
		const { setLoading } = this.context;
		setLoading(true);
		axios({
			method: 'GET',
			url: API_URL,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {
			if (ress.data && ress.status === 200) {
				self.setState({
					activation_reward: [...self.state.activation_reward, ...ress.data.data],
					activation_reward_is_load: true,
					filterActivationReward: ress.data.total_amount,
					BQ_next_page_url: (ress.data && ress.data.links && ress.data.links.next) ? ress.data.links.next : null,
					BQ_prev_page_url: (ress.data && ress.data.links && ress.data.links.prev) ? ress.data.links.prev : null,
				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	getNextDataPQ(API) {
		if (!API) {
			toast.error(strings.URI_not_found);
			return false;
		}
		var API_URL = API;
		if (this.state.PQ_startDate && this.state.PQ_endDate) {
			API_URL = API + "&start_date=" + (this.state.PQ_startDate ? moment(this.state.PQ_startDate).format("YYYY-MM-DD") : "") + "&end_date=" + (this.state.PQ_endDate ? moment(this.state.PQ_endDate).format("YYYY-MM-DD") : "");
		}
		var self = this;
		self.setState({
			nextPageLink: "",
			prevPageLink: "",
		});
		const { setLoading } = this.context;
		setLoading(true);
		axios({
			method: 'GET',
			url: API_URL,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {
			if (ress.data && ress.status === 200) {
				self.setState({
					profit_reward: [...self.state.profit_reward, ...ress.data.data],
					profit_reward_is_load: true,
					filterProfitReward: ress.data.total_amount,
					PQ_next_page_url: (ress.data && ress.data.links && ress.data.links.next) ? ress.data.links.next : null,
					PQ_prev_page_url: (ress.data && ress.data.links && ress.data.links.prev) ? ress.data.links.prev : null,
				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	openModal = (data) => {
		this.setState({ showModalData: {} });
		setTimeout(() => {
			this.setState({
				showModal: true,
				showModalData: data
			});
		});
	};

	closeModal = () => {
		this.setState({ showModal: false });
	};

	// Native date-range handler: prefix = 'TP' | 'BQ' | 'PQ', which = 'start' | 'end'
	handleNativeRange = (prefix, which, value, reportFn) => {
		const key = which === 'start' ? `${prefix}_startDate` : `${prefix}_endDate`;
		this.setState({ [key]: value || null }, () => {
			const start = this.state[`${prefix}_startDate`];
			const end = this.state[`${prefix}_endDate`];
			// Fetch when both ends are set, or when both are cleared (show all)
			if ((start && end) || (!start && !end)) {
				reportFn.call(this);
			}
		});
	};

	botName(type) {
		if (type == 0) return "DCA";
		if (type == 1) return "CTS";
		if (type == 2) return "AI";
		return "";
	}

	formatAmount(amount) {
		const value = Number.parseFloat(amount || 0);
		return (value > 0 ? "+" : "") + value.toFixed(5);
	}

	// Summary card: total earned + From/To filter for one tab
	renderSummary(total, prefix, reportFn) {
		const start = this.state[`${prefix}_startDate`];
		const end = this.state[`${prefix}_endDate`];
		return (
			<section className="rw-summary">
				<div className="rw-summary-label">{strings.total_profit_earned}</div>
				<div className="rw-summary-value">{total}</div>
				<div className="date-range-native rw-range">
					<div className='drn-field'>
						<label className='drn-label'>{strings.from_date}</label>
						<NativeDateField value={start || ''} max={end || undefined}
							onChange={(e) => this.handleNativeRange(prefix, 'start', e.target.value, reportFn)} />
					</div>
					<div className='drn-field'>
						<label className='drn-label'>{strings.to_date}</label>
						<NativeDateField value={end || ''} min={start || undefined}
							onChange={(e) => this.handleNativeRange(prefix, 'end', e.target.value, reportFn)} />
					</div>
				</div>
			</section>
		);
	}

	renderNoSummary() {
		return (
			<div className="text-center" style={{ marginTop: 25 }}>
				<img src={NoDataFound} alt="CTS Bot" width={100}></img>
			</div>
		);
	}

	renderLoadMore(url, loadFn) {
		if (!url) {
			return null;
		}
		return (
			<button type="button" className="m-btn m-btn-ghost rw-load-more" onClick={() => loadFn.call(this, url)}>
				{strings.Load_More}
			</button>
		);
	}

	renderEmpty(isLoad, list) {
		if (!isLoad || (list && list.length !== 0)) {
			return null;
		}
		return <div className="rw-empty">{strings.no_records_found}</div>;
	}

	// Trading profit rows: bot badge, pair + time, amount; tap opens details
	renderTradingList(list) {
		return (
			<ul className="rw-list">
				{list.map((item, i) => (
					<li key={item.id || i}>
						<button type="button" className="rw-row" onClick={() => this.openModal(item)}>
							<span className={`rw-badge rw-badge-${this.botName(item.type).toLowerCase()}`}>{this.botName(item.type)}</span>
							<span className="rw-main">
								<span className="rw-title">{item.pair || '-'}</span>
								<span className="rw-sub">{item.created_at ? moment(item.created_at).format("YYYY-MM-DD HH:mm:ss") : ''}</span>
							</span>
							<span className="rw-side">
								<span className="rw-amount">{this.formatAmount(item.amount)}</span>
								<span className="rw-link">{strings.details}<IconChevronRight size={14} strokeWidth={2.2} /></span>
							</span>
						</button>
					</li>
				))}
			</ul>
		);
	}

	// Quantification rows: icon, description + time, amount
	renderRewardList(list, Icon) {
		return (
			<ul className="rw-list">
				{list.map((item, i) => (
					<li key={item.id || i}>
						<div className="rw-row">
							<span className="rw-badge rw-badge-icon"><Icon size={18} /></span>
							<span className="rw-main">
								<span className="rw-title rw-title-wrap">{item.description || strings.profit}</span>
								<span className="rw-sub">{item.created_at ? moment(item.created_at).format("YYYY-MM-DD HH:mm:ss") : ''}</span>
							</span>
							<span className="rw-side">
								<span className="rw-amount">{this.formatAmount(item.amount)}</span>
							</span>
						</div>
					</li>
				))}
			</ul>
		);
	}

	render() {
		const { data } = this.state;

		const tradingTotal = this.state.filterProfit == 0
			? ((data.trading_profit && data.trading_profit.profit_today && data.trading_profit.profit_today > 0) ? "+" + Number.parseFloat(data.trading_profit.profit_today).toFixed(5) : Number.parseFloat(0).toFixed(5))
			: this.state.filterProfit;
		const botTotal = this.state.filterActivationReward == 0
			? ((data.profit_quantification && data.bot_quantification && data.bot_quantification.profit_today) ? Number.parseFloat(data.bot_quantification.profit_today).toFixed(5) : Number.parseFloat(0).toFixed(5))
			: this.state.filterActivationReward;
		const profitTotal = this.state.filterProfitReward == 0
			? ((data.profit_quantification && data.profit_quantification.profit_today) ? Number.parseFloat(data.profit_quantification.profit_today).toFixed(5) : Number.parseFloat(0).toFixed(5))
			: this.state.filterProfitReward;

		return (
			<SubLayout data={{ "title": strings.reward_details }}>
				<div className='offset-md-4 col-md-4 rw-page'>
					<Tabs
						className="rw-tabs"
						value={this.state.tabValue}
						onChange={this.handleChange}
						variant="fullWidth"
						aria-label="reward tabs"
					>
						<Tab label={strings.Trading_Profit} />
						<Tab label={strings.bot_quantification} />
						<Tab label={strings.profit_quantification} />
					</Tabs>
					<SwipeableViews index={this.state.tabValue} onChangeIndex={(index) => this.setState({ tabValue: index })} style={{ minHeight: "calc(100vh - 150px)" }}>
						<div role="tabpanel" hidden={this.state.tabValue !== 0}>
							{this.state.tabValue === 0 && (
								<>
									{data && data.trading_profit ? this.renderSummary(tradingTotal, 'TP', this.getProfitReport) : this.renderNoSummary()}
									{this.state.profit_data_is_load && this.state.profit_data && this.state.profit_data.length !== 0 ? this.renderTradingList(this.state.profit_data) : null}
									{this.renderEmpty(this.state.profit_data_is_load, this.state.profit_data)}
									{this.renderLoadMore(this.state.TP_next_page_url, this.getNextDataTP)}
								</>
							)}
						</div>
						<div role="tabpanel" hidden={this.state.tabValue !== 1}>
							{this.state.tabValue === 1 && (
								<>
									{data && data.bot_quantification ? this.renderSummary(botTotal, 'BQ', this.getActivationReward) : this.renderNoSummary()}
									{this.state.activation_reward_is_load && this.state.activation_reward && this.state.activation_reward.length !== 0 ? this.renderRewardList(this.state.activation_reward, IconZap) : null}
									{this.renderEmpty(this.state.activation_reward_is_load, this.state.activation_reward)}
									{this.renderLoadMore(this.state.BQ_next_page_url, this.getNextDataBQ)}
								</>
							)}
						</div>
						<div role="tabpanel" hidden={this.state.tabValue !== 2}>
							{this.state.tabValue === 2 && (
								<>
									{data && data.profit_quantification ? this.renderSummary(profitTotal, 'PQ', this.getProfitReward) : this.renderNoSummary()}
									{this.state.profit_reward_is_load && this.state.profit_reward && this.state.profit_reward.length !== 0 ? this.renderRewardList(this.state.profit_reward, IconUsers) : null}
									{this.renderEmpty(this.state.profit_reward_is_load, this.state.profit_reward)}
									{this.renderLoadMore(this.state.PQ_next_page_url, this.getNextDataPQ)}
								</>
							)}
						</div>
					</SwipeableViews>
				</div>

				<Modal
					open={this.state.showModal}
					onClose={() => this.closeModal()}
					className="itemModal reward-modal-root"
					style={{ overflow: 'scroll' }}
				>
					<div className="modal-dialog modal-dialog-centered reward-modal-dialog">
						<div className="modal-content dark-modal-overlay reward-detail-modal">
							<div className="reward-detail-header">
								<div className="reward-detail-subtitle">
									<span className="reward-detail-bot-tag">
										{this.state.showModalData.type === 0 ? "DCA" : ""}
										{this.state.showModalData.type === 1 ? "CTS" : ""}
										{this.state.showModalData.type === 2 ? "AI" : ""} {strings.bot}
									</span>
									<span>{strings.details}</span>
								</div>
								<button onClick={() => this.closeModal()} type="button" className="reward-detail-close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div className="modal-body reward-detail-body">
								<div className="reward-detail-hero">
									<div className="reward-detail-title">
										{(this.state.showModalData && this.state.showModalData.pair) ? this.state.showModalData.pair : ""}
									</div>
									<span>{strings.profit}</span>
									<strong>{Number.parseFloat(this.state.showModalData.amount).toFixed(5)}</strong>
								</div>
								<div className="reward-detail-grid border-0">
									<div className='reward-detail-row'>
										<span>{strings.coin_qty}</span>
										<strong>{Number.parseFloat((this.state.showModalData && this.state.showModalData.quantity && this.state.showModalData.quantity) ? this.state.showModalData.quantity : 0).toFixed(2)}</strong>
									</div>
									<div className='reward-detail-row'>
										<span>{strings.usdt_qty}</span>
										<strong>{Number.parseFloat((this.state.showModalData && this.state.showModalData.cost && this.state.showModalData.cost) ? this.state.showModalData.cost : 0).toFixed(2)}</strong>
									</div>
									<div className='reward-detail-row'>
										<span>{strings.average_buy_price}</span>
										<strong>{Number.parseFloat((this.state.showModalData && this.state.showModalData.data && this.state.showModalData.data.price) ? (this.state.showModalData.cost / this.state.showModalData.quantity) : 0).toFixed(5)}</strong>
									</div>
									<div className='reward-detail-row'>
										<span>{strings.sell_price}</span>
										<strong>{Number.parseFloat((this.state.showModalData && this.state.showModalData.data && this.state.showModalData.data.price) ? this.state.showModalData.data.price : 0).toFixed(5)}</strong>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Modal>

			</SubLayout>
		);
	}
}

export default RewardScreen;
